import React from 'react';
import { formatTime } from '../../utils/formatters';

export function PriceVoteRow({ vote }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 80px 70px',
      gap: '16px',
      padding: '10px 16px',
      borderBottom: '1px solid var(--border-subtle)',
      alignItems: 'center',
      fontSize: '12px',
    }}>
      <div style={{ color: 'var(--text-tertiary)', fontFamily: 'var(--font-mono)' }}>
        {vote.payload?.sv?.split('::')[0] || 'Unknown'}
      </div>
      <div style={{
        color: 'var(--text-secondary)',
        fontFamily: 'var(--font-mono)',
        fontWeight: '600',
        textAlign: 'right',
      }}>
        ${parseFloat(vote.payload?.amuletPrice || 0).toFixed(4)}
      </div>
      <div style={{ color: 'var(--text-disabled)', textAlign: 'right' }}>
        {formatTime(vote.payload?.lastUpdatedAt)}
      </div>
    </div>
  );
}
